export * from './customer-registration-success/customer-registration-success.component';
export * from './customer-registration.smart.component';
